module.exports = __webpack_public_path__ + "app/admin/audit/audit-3KpkDl5j.html";